/**
 * Helper functions for cart display and calculations
 */

/**
 * Format a number as currency
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};
